import {
  AreaItemType,
  ConditionEqualityType,
  ConditionField,
  DimensionDescriptor,
} from "../../../../../shared/reporting/api/biClient.types";
import { generateGuid } from "../../../../../shared/utilities/generateGuid";

export function createEmptyConditionItem(meta: DimensionDescriptor): ConditionField {
  return {
    meta: meta,
    areaItemType: AreaItemType.CONDITIONS,
    config: {
      guid: generateGuid(),

      filter: {
        dimensionName: meta.name,
        values: [],
        equalityType: ConditionEqualityType.Equal,
      },
    },
    dictionary: { loaded: false, loading: false },
  };
}
